import type {ResourceLink} from '../../types';
import {safeUriDecode} from '../../utils';

export function findResourceLink(key: string, links?: ResourceLink[] | null): ResourceLink | undefined {
    return links?.find((link) => link.rel === key);
}

export function cleanResourceLinks(links: ResourceLink[]): ResourceLink[] {
    return links.map(({href, ...rest}) => ({...rest, href: safeUriDecode(href)}));
}
